/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".process-slide-toggle[_ngcontent-%COMP%]{margin-bottom:20px}"];
export { styles as styles };
